module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-4.257587e7.svg";